import { useI18n } from '@/lib/i18n';

// Public DE | EN language switcher. Only calls setLang (context + localStorage),
// so it never navigates or remounts the page — any form data in local state is
// preserved across a language switch.
export default function LangToggle({ className = '' }) {
  const { lang, setLang } = useI18n();
  return (
    <div
      data-testid="lang-toggle"
      className={`inline-flex items-center gap-0.5 rounded-full border border-white/[0.12] bg-black/30 p-0.5 text-[11px] font-bold backdrop-blur-md ${className}`}
    >
      {['de', 'en'].map((l) => (
        <button
          key={l}
          type="button"
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
          className={`rounded-full px-2.5 py-1 tracking-wide transition-colors ${
            lang === l ? 'bg-asgym-accent text-black' : 'text-asgym-sub hover:text-white'
          }`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
